namespace TabAurous.OMS {
    export interface PriceListForm {
        PriceCode: Serenity.StringEditor;
        PriceName: Serenity.StringEditor;
        PriceType: Serenity.LookupEditor;
        Narration: Serenity.StringEditor;
        RateDetails: PriceListDetailsEditor;
        ItemDetails: FixedRateMasterEditor;
        LaborDetails: LabourPriceListDetailsEditor;
    }

    export class PriceListForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.PriceList';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PriceListForm.init)  {
                PriceListForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = PriceListDetailsEditor;
                var w3 = FixedRateMasterEditor;
                var w4 = LabourPriceListDetailsEditor;

                Q.initFormType(PriceListForm, [
                    'PriceCode', w0,
                    'PriceName', w0,
                    'PriceType', w1,
                    'Narration', w0,
                    'RateDetails', w2,
                    'ItemDetails', w3,
                    'LaborDetails', w4
                ]);
            }
        }
    }
}
